import React from 'react';

const ExpandableSection = (Component, ...props) => {

  return class extends React.Component {
    static displayName = `${Component.name}Container`;

    constructor(props) {
      super(props);

      this.toggleClick = this.toggleClick.bind(this);

      this.state = {
        open: false
      };
    }

    toggleClick(event) {
      this.setState({ open: !this.state.open });
    }

    render() {
      return (
        <section className={"filters" + (this.state.open ? ' open' : ' closed')}>
          <Component toggleAction={this.toggleClick} {...this.props} />
        </section>
      );
    }
  }
}

export default ExpandableSection;



// WEBPACK FOOTER //
// ./src/components/common/ExpandableSection.js